const mapper_options = {
  endpoint: 'campaign_spending_summaries',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      campaign: {
        foreignKey: 'campaign_id',
        localField: 'campaign'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('campaign_spending_summaries', mapper_options)
}
